var _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressFace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 438.938,
    height: 512.728,
    viewBox: "0 0 116.136 135.659",
    id: "svg848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs842"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3805-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.655 340.683h11.779v-16.831h-11.779z",
    id: "path3803-9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3571"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2177.778h1540.185V0H0z",
    id: "path3569"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3757"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.651 272.247h17.915v-12.985h-17.915z",
    id: "path3755"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3773"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.466 272.247h17.915v-12.985h-17.915z",
    id: "path3771"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3789"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.054 243.127h40.921v-4.219h-40.921z",
    id: "path3787"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3805"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.655 340.683h11.779v-16.831h-11.779z",
    id: "path3803"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3821"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.669 328.81h5.304v-5.329h-5.304z",
    id: "path3819"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3837"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.082 328.81h5.303v-5.329h-5.303z",
    id: "path3835"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3853"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.475 360.982h11.779v-16.831h-11.779z",
    id: "path3851"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3869"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.489 349.109h5.304v-5.329h-5.304z",
    id: "path3867"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3885"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.901 349.109h5.304v-5.329h-5.304z",
    id: "path3883"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3901"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.316 349.109h5.304v-5.329h-5.304z",
    id: "path3899"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3571-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2177.778h1540.185V0H0z",
    id: "path3569-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3741-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.05 342.973h142.728V178.667H800.05z",
    id: "path3739-0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3757-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.651 272.247h17.915v-12.985h-17.915z",
    id: "path3755-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3773-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.466 272.247h17.915v-12.985h-17.915z",
    id: "path3771-5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3789-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.054 243.127h40.921v-4.219h-40.921z",
    id: "path3787-4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3805-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.655 340.683h11.779v-16.831h-11.779z",
    id: "path3803-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3821-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.669 328.81h5.304v-5.329h-5.304z",
    id: "path3819-4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3837-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.082 328.81h5.303v-5.329h-5.303z",
    id: "path3835-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3853-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.475 360.982h11.779v-16.831h-11.779z",
    id: "path3851-4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3869-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.489 349.109h5.304v-5.329h-5.304z",
    id: "path3867-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3885-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.901 349.109h5.304v-5.329h-5.304z",
    id: "path3883-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3901-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.316 349.109h5.304v-5.329h-5.304z",
    id: "path3899-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3571-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2177.778h1540.185V0H0z",
    id: "path3569-80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3741-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.05 342.973h142.728V178.667H800.05z",
    id: "path3739-9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3757-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.651 272.247h17.915v-12.985h-17.915z",
    id: "path3755-9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3773-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.466 272.247h17.915v-12.985h-17.915z",
    id: "path3771-58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3789-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.054 243.127h40.921v-4.219h-40.921z",
    id: "path3787-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3741"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.05 342.973h142.728V178.667H800.05z",
    id: "path3739"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3821-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.669 328.81h5.304v-5.329h-5.304z",
    id: "path3819-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3837-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.082 328.81h5.303v-5.329h-5.303z",
    id: "path3835-16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3853-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.475 360.982h11.779v-16.831h-11.779z",
    id: "path3851-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3869-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.489 349.109h5.304v-5.329h-5.304z",
    id: "path3867-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3885-02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.901 349.109h5.304v-5.329h-5.304z",
    id: "path3883-5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3901-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.316 349.109h5.304v-5.329h-5.304z",
    id: "path3899-9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3571-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2177.778h1540.185V0H0z",
    id: "path3569-7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3741-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.05 342.973h142.728V178.667H800.05z",
    id: "path3739-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3757-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.651 272.247h17.915v-12.985h-17.915z",
    id: "path3755-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3773-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.466 272.247h17.915v-12.985h-17.915z",
    id: "path3771-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3789-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.054 243.127h40.921v-4.219h-40.921z",
    id: "path3787-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3805-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.655 340.683h11.779v-16.831h-11.779z",
    id: "path3803-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3821-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.669 328.81h5.304v-5.329h-5.304z",
    id: "path3819-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3837-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.082 328.81h5.303v-5.329h-5.303z",
    id: "path3835-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3853-04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.475 360.982h11.779v-16.831h-11.779z",
    id: "path3851-7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3869-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.489 349.109h5.304v-5.329h-5.304z",
    id: "path3867-31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3885-09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.901 349.109h5.304v-5.329h-5.304z",
    id: "path3883-4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3901-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.316 349.109h5.304v-5.329h-5.304z",
    id: "path3899-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3901-6-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.316 349.109h5.304v-5.329h-5.304z",
    id: "path3899-3-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3885-09-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.901 349.109h5.304v-5.329h-5.304z",
    id: "path3883-4-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3869-44-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.489 349.109h5.304v-5.329h-5.304z",
    id: "path3867-31-7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3853-04-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.475 360.982h11.779v-16.831h-11.779z",
    id: "path3851-7-5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3837-2-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.082 328.81h5.303v-5.329h-5.303z",
    id: "path3835-6-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3821-7-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.669 328.81h5.304v-5.329h-5.304z",
    id: "path3819-6-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3805-1-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.655 340.683h11.779v-16.831h-11.779z",
    id: "path3803-3-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3789-3-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.054 243.127h40.921v-4.219h-40.921z",
    id: "path3787-3-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3773-5-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M903.466 272.247h17.915v-12.985h-17.915z",
    id: "path3771-3-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3757-0-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.651 272.247h17.915v-12.985h-17.915z",
    id: "path3755-2-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3741-7-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.05 342.973h142.728V178.667H800.05z",
    id: "path3739-3-5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-44.742 6.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1431",
    transform: "matrix(.26458 0 0 .26458 34.825 -6.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1399",
    style: {
      stroke: "#fff",
      strokeWidth: 12.71811008,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1397",
    style: {
      stroke: "#fff",
      strokeWidth: 12.71811008,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1395",
    d: "M470.06 256.34c0 138.07-95.41 250.01-213.11 250.01-117.7 0-213.11-111.93-213.11-250.01 0-138.06 95.41-250 213.11-250 117.7.01 213.11 111.94 213.11 250z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 12.71811008,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1401",
    d: "M330.41 148.41c8.83-3.99 18.49-4.92 28.01-4a62.767 62.767 0 0 1 27.66 9.86c8.59 5.56 16.08 13.57 21.51 22.99 5.43 9.43 8.91 20.14 9.91 31.12-5.34-9.08-10.61-17.47-16.68-24.68-6.04-7.23-12.76-13.25-20.13-18.07-7.37-4.83-15.37-8.46-23.79-11.19-8.43-2.72-17.2-4.65-26.49-6.03z",
    className: "st1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1405",
    d: "M183.49 148.41c-9.29 1.38-18.05 3.31-26.49 6.04-8.42 2.73-16.42 6.36-23.79 11.19-7.37 4.82-14.1 10.84-20.13 18.07-6.07 7.21-11.35 15.6-16.68 24.68 1-10.97 4.49-21.68 9.91-31.12 5.43-9.42 12.93-17.43 21.51-22.99a62.6 62.6 0 0 1 27.66-9.86c9.52-.94 19.18-.01 28.01 3.99z",
    className: "st1",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1411",
    d: "M369.87 360.01c-2.89 3.1-5.81 6.14-8.78 9.09-2.98 2.93-5.92 5.94-8.94 8.8-5.99 5.8-12.09 11.41-18.21 16.98l-2.8 2.54-3.69-2.97c-6.37-5.13-12.69-10.33-18.95-15.61l-9.35-7.98-9.27-8.1 10.3.18-9.29 8.92c-3.09 2.99-6.24 5.89-9.36 8.81-6.24 5.88-12.6 11.57-18.91 17.34l-5.59 5.1-5.6-5.09c-6.34-5.76-12.73-11.44-18.98-17.32-3.13-2.93-6.3-5.81-9.4-8.8l-9.33-8.91 10.32-.19c-6.17 5.41-12.36 10.8-18.62 16.08-3.11 2.66-6.29 5.24-9.43 7.86l-9.52 7.74-3.68 2.99-2.83-2.57c-6.12-5.57-12.22-11.18-18.21-16.98-3.02-2.86-5.95-5.88-8.93-8.81-2.97-2.95-5.89-6-8.77-9.1 3.6 1.8 7.17 3.65 10.69 5.61 3.51 1.97 7.06 3.85 10.53 5.9 6.98 4 13.86 8.19 20.71 12.43l-6.51.43 8.39-9.37c2.83-3.08 5.62-6.2 8.48-9.24 5.68-6.12 11.42-12.15 17.19-18.14l4.71-4.89 5.61 4.69 9.8 8.19c3.28 2.71 6.48 5.53 9.73 8.3 6.49 5.52 12.85 11.25 19.26 16.89l-11.19.01c6.39-5.64 12.74-11.35 19.21-16.88 3.23-2.78 6.43-5.58 9.7-8.3l9.77-8.19 5.61-4.7 4.69 4.89 8.64 9.01 8.56 9.13c5.68 6.12 11.3 12.33 16.86 18.61l-6.48-.42c6.85-4.24 13.73-8.43 20.71-12.43 3.47-2.04 7.02-3.93 10.52-5.91 3.46-1.96 7.03-3.82 10.63-5.62z",
    className: "st1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1415",
    d: "M392.12 267.06c-3.21-.64-6.35-1.47-9.49-2.32-3.14-.83-6.24-1.79-9.33-2.75-6.18-1.96-12.29-4.13-18.35-6.42-6.06-2.3-12.06-4.77-18.03-7.34-5.96-2.57-11.87-5.3-17.76-8.1l-.02-.01c-3.27-1.55-4.84-5.92-3.52-9.75.67-1.96 2-3.41 3.54-4.14l8.85-4.15 8.91-3.96c5.97-2.57 11.96-5.06 18.03-7.35 6.06-2.29 12.17-4.47 18.35-6.42 3.1-.96 6.19-1.92 9.34-2.75 3.13-.85 6.28-1.67 9.49-2.31-2.67 2.19-5.4 4.19-8.14 6.16-2.74 2-5.52 3.86-8.3 5.73-5.57 3.69-11.22 7.17-16.92 10.52-5.69 3.36-11.45 6.52-17.24 9.6l-8.72 4.51-8.79 4.32v-13.9c5.87 2.85 11.71 5.77 17.5 8.85 5.79 3.07 11.54 6.25 17.24 9.6 5.69 3.36 11.34 6.83 16.92 10.52 2.78 1.86 5.56 3.73 8.3 5.72 2.74 1.96 5.47 3.96 8.14 6.14z",
    className: "st1",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1421",
    d: "M121.79 267.06c2.67-2.18 5.4-4.18 8.15-6.15 2.74-1.99 5.51-3.86 8.3-5.72 5.58-3.69 11.23-7.17 16.92-10.52 5.69-3.35 11.45-6.53 17.24-9.6 5.79-3.07 11.64-5.99 17.5-8.85v13.9l-8.79-4.32-8.72-4.51c-5.79-3.08-11.55-6.24-17.24-9.6-5.69-3.35-11.34-6.83-16.92-10.52-2.78-1.86-5.56-3.73-8.3-5.73-2.74-1.98-5.48-3.98-8.14-6.16 3.21.64 6.35 1.46 9.49 2.31 3.14.83 6.24 1.79 9.34 2.75 6.18 1.95 12.29 4.13 18.35 6.42 6.06 2.29 12.06 4.78 18.02 7.35l8.91 3.96 8.85 4.15c3.27 1.54 4.86 5.9 3.55 9.73-.67 1.96-1.97 3.41-3.51 4.15l-.04.02c-5.89 2.8-11.8 5.53-17.76 8.1-5.97 2.57-11.97 5.04-18.03 7.34-6.06 2.29-12.17 4.47-18.35 6.42-3.1.96-6.19 1.92-9.34 2.75-3.13.86-6.27 1.69-9.48 2.33z",
    className: "st1",
    style: {
      fill: "#fff"
    }
  }))))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style1393",
    type: "text/css"
  }, ".st1{fill:#fff}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressFace);
export default __webpack_public_path__ + "static/media/stress_face.905b93993385429b7fa37cdd68d03caf.svg";
export { ForwardRef as ReactComponent };